const container = document.querySelector(".webshop__product-image-preview");
if (container) {
    const buttons = document.querySelectorAll('.webshop__product-image-button');
    if (buttons.length) {
        const largeImage = document.getElementById('webshop__product-large-image');
        for (let i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener('click', () => {
                largeImage.src = buttons[i].src;
            });
        }
    }
}

const radio_size_all = document.querySelectorAll(".webshop__product-details-size-radio");
const price_div_all = document.querySelectorAll(".webshop__product-purchase-price-div");
const amount_select_all = document.querySelectorAll(".webshop__product-details-amount-select");
if (radio_size_all) {
    const label_elements = document.querySelectorAll('.webshop__product-details-size-label');
    if (label_elements.length) {
        for (let i = 0; i < label_elements.length; i++) {
            label_elements[i].addEventListener('click', () => {
                let current_id = label_elements[i].id;
                let current_price_div = document.getElementById('webshop__product-purchase-price-'+current_id);
                let current_amount_select = document.getElementById('webshop__product-details-amount-select-'+current_id);
                let current_radio_size = document.getElementById('webshop__product-details-size-radio-'+current_id);
                if (typeof radio_size_all === 'undefined' || radio_size_all === null || radio_size_all.length < 1) {
                    return;
                }
                if (typeof current_price_div === 'undefined' || current_price_div === null) {
                    return;
                }
                if (typeof current_amount_select === 'undefined' || current_amount_select === null) {
                    return;
                }
                if (typeof current_radio_size === 'undefined' || current_radio_size === null) {
                    return;
                }
                if (current_radio_size.disabled) {
                    return;
                }
                for (let j = 0; j < radio_size_all.length; j++) {
                    radio_size_all[j].checked = false;
                }
                for (let j = 0; j < price_div_all.length; j++) {
                    price_div_all[j].classList.remove("webshop__product-purchase-price-div--active");
                }
                for (let j = 0; j < amount_select_all.length; j++) {
                    amount_select_all[j].classList.remove("webshop__product-details-amount-select--active");
                }
                document.getElementById('purchasableId').value = current_id;
                document.getElementById('qty').value = current_amount_select.value;
                current_radio_size.checked = true;
                current_price_div.classList.add("webshop__product-purchase-price-div--active");
                current_amount_select.classList.add("webshop__product-details-amount-select--active");
            });
        }
    }
}

// Pickup location label clicks — show the selected office address and update hidden shipping input
const radio_shipping_all = document.querySelectorAll(".delivery__form-item-radio");
if (radio_shipping_all.length) {
    const label_elements = document.querySelectorAll('.delivery__form-item-label');
    for (let i = 0; i < label_elements.length; i++) {
        label_elements[i].addEventListener('click', () => {
            let current_id = label_elements[i].id;
            let current_radio_shipping = document.getElementById('delivery__form-item-radio-' + current_id);
            if (!current_radio_shipping) return;
            for (let j = 0; j < radio_shipping_all.length; j++) {
                radio_shipping_all[j].checked = false;
            }
            current_radio_shipping.checked = true;
            let addresses = document.querySelectorAll('.delivery__form-item-pickup-address');
            for (let k = 0; k < addresses.length; k++) {
                addresses[k].classList.remove('delivery__form-item-pickup-address--active');
            }
            let current_address = document.getElementById('delivery__form-item-address-' + current_id);
            if (current_address) {
                current_address.classList.add('delivery__form-item-pickup-address--active');
            }
        });
    }
}

// Top-level delivery choice (Hent selv / Send hjem) — for deliverable items
const choiceLabels = document.querySelectorAll('.delivery__choice-label');
if (choiceLabels.length) {
    choiceLabels.forEach(function(label) {
        label.addEventListener('click', function() {
            const radio = document.getElementById(label.getAttribute('for'));
            if (radio) handleDeliveryTopLevelChoice(radio.value);
        });
    });

    // Also respond to keyboard navigation changing the radio
    document.querySelectorAll('.delivery__choice-radio').forEach(function(radio) {
        radio.addEventListener('change', function() {
            handleDeliveryTopLevelChoice(this.value);
        });
    });

    // Restore state on page load if a choice was pre-selected
    const preChecked = document.querySelector('.delivery__choice-radio:checked');
    if (preChecked) handleDeliveryTopLevelChoice(preChecked.value);
}

function handleDeliveryTopLevelChoice(choice) {
    const pickupSection = document.getElementById('delivery-pickup-section');
    const deliverySection = document.getElementById('delivery-delivery-section');
    const deliveryRadio = document.getElementById('delivery-radio-delivery');

    if (choice === 'pickup') {
        if (pickupSection) pickupSection.style.display = 'block';
        if (deliverySection) deliverySection.style.display = 'none';
        if (deliveryRadio) deliveryRadio.checked = false;
        setDeliveryAddressFieldsDisabled(true);
        // Ensure a pickup option is selected; default to the first if none is checked
        var checkedPickup = document.querySelector('[data-type="pickup"].delivery__form-item-radio:checked');
        if (!checkedPickup) {
            checkedPickup = document.querySelector('[data-type="pickup"].delivery__form-item-radio');
            if (checkedPickup) checkedPickup.checked = true;
        }
        // Show the selected pickup's address
        document.querySelectorAll('.delivery__form-item-pickup-address').forEach(function(el) { el.classList.remove('delivery__form-item-pickup-address--active'); });
        if (checkedPickup) {
            var activeAddr = document.getElementById(checkedPickup.id.replace('delivery__form-item-radio-', 'delivery__form-item-address-'));
            if (activeAddr) activeAddr.classList.add('delivery__form-item-pickup-address--active');
        }
    } else {
        if (pickupSection) pickupSection.style.display = 'none';
        if (deliverySection) deliverySection.style.display = 'block';
        document.querySelectorAll('[data-type="pickup"].delivery__form-item-radio').forEach(function(r) { r.checked = false; });
        if (deliveryRadio) deliveryRadio.checked = true;
        setDeliveryAddressFieldsDisabled(false);
    }
}

function setDeliveryAddressFieldsDisabled(disable) {
    var deliverySection = document.getElementById('delivery-delivery-section');
    if (!deliverySection) return;
    deliverySection.querySelectorAll('input[name^="shippingAddress"], select[name^="shippingAddress"]').forEach(function(el) {
        el.disabled = disable;
    });
}

const flashnotice = document.querySelectorAll(".flashnotice");
if (flashnotice && flashnotice.length>0) {
    let flashnoticeElement = flashnotice[0];
    if (flashnoticeElement) {
        setTimeout( function () {
            fade(flashnoticeElement);
        }, 4000);
    }
}

function fade(element) {
    var op = 1;  // initial opacity
    var timer = setInterval(function () {
        if (op <= 0.1){
            clearInterval(timer);
            element.style.display = 'none';
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op -= op * 0.1;
    }, 50);
}